var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_47129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7109 13.6996V8.80902C31.7109 6.74716 30.0395 5.07568 27.9776 5.07568H4.05365C1.99178 5.07568 0.320312 6.74715 0.320312 8.80902V25.4604C0.320312 26.8698 1.46301 28.0125 2.8724 28.0125H24.8809L28.2656 31.3621L30.7539 28.9377L29.7567 27.9417C30.8777 27.6731 31.7109 26.6638 31.7109 25.4604V19.3354V13.6996Z",
    fill: "url(#paint0_linear_1433_47129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0155 6.80029L16.4822 19.867L1.54883 6.80029",
    stroke: "url(#paint1_linear_1433_47129)",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0091 25.4606C20.8542 25.4606 24.7819 21.5329 24.7819 16.6878C24.7819 11.8427 20.8542 7.91504 16.0091 7.91504C11.164 7.91504 7.23633 11.8427 7.23633 16.6878C7.23633 21.5329 11.164 25.4606 16.0091 25.4606Z",
    fill: "#FAF7F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0098 22.9087C19.4454 22.9087 22.2305 20.1236 22.2305 16.688C22.2305 13.2524 19.4454 10.4673 16.0098 10.4673C12.5742 10.4673 9.78906 13.2524 9.78906 16.688C9.78906 20.1236 12.5742 22.9087 16.0098 22.9087Z",
    fill: "url(#paint2_linear_1433_47129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 19.1692L13.5273 14.2065",
    stroke: "white",
    strokeWidth: 0.933333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 14.2065L13.5273 19.1692",
    stroke: "white",
    strokeWidth: 0.933333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9575 23.8297L23.1525 25.6347L21.2461 23.7283C21.9313 23.2172 22.54 22.6086 23.0511 21.9233L24.9575 23.8297Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7489 28.9378L28.2606 31.3623L22.8145 25.973L25.2957 23.4917L30.7489 28.9378Z",
    fill: "#FFC245"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_47129",
    x1: 16.0156,
    y1: 5.07568,
    x2: 16.0156,
    y2: 31.3621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AA2D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_47129",
    x1: 15.7822,
    y1: 6.80029,
    x2: 15.7822,
    y2: 19.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1433_47129",
    x1: 16.0098,
    y1: 10.4673,
    x2: 16.0098,
    y2: 22.9087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C4A",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_47129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon7);
export default __webpack_public_path__ + "static/media/mail_card_icon7.bbdc7601c13b970b4e8c7eef829de520.svg";
export { ForwardRef as ReactComponent };